export type PublicConfig = {
  posthogKey: string;
  posthogHost: string;
  turnstileSiteKey: string;
};

const DEFAULT_POSTHOG_HOST = "https://us.i.posthog.com";

function trimOrEmpty(value: unknown): string {
  return typeof value === "string" ? value.trim() : "";
}

const config: PublicConfig = {
  posthogKey: trimOrEmpty(process.env.BUN_PUBLIC_POSTHOG_KEY),
  posthogHost:
    trimOrEmpty(process.env.BUN_PUBLIC_POSTHOG_HOST) || DEFAULT_POSTHOG_HOST,
  turnstileSiteKey: trimOrEmpty(process.env.BUN_PUBLIC_TURNSTILE_SITE_KEY),
};

export function getPublicConfig(): PublicConfig {
  return config;
}
